export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10911.3d431ddb.jpg";